module.exports = __webpack_public_path__ + "media/images/glyphicons-17-bin-487f99adef2a7a5b4b1cbb3e5a44d447.png";